import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <section className="section" data-testid="not-found">
      <SEO title="Page not found" path="/404" noindex />
      <div className="container-site max-w-xl text-center py-10">
        <span className="eyebrow">404</span>
        <h1 className="mt-3 text-4xl">We couldn't find that page.</h1>
        <p className="mt-4 text-body">The page may have moved. Let's get you back on track.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/" className="btn btn-primary">Go home</Link>
          <Link to="/contact" className="btn btn-secondary">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
